module.exports = __webpack_public_path__ + "media/images/name-film-f3b0ab0977201dfd5fe316910f5adfc0.png";